import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCustom, SearchBarBox, HeadlinePage } from 'components/common';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SyncIcon from '@mui/icons-material/Sync';
import { Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { withPermission } from 'hoc';


const ProjectListDumb = ({
  handleSearch,
  searchValue,
  handleCreate,
  handleEdit,
  handleDelete,
  defaultValues,
  content,
  options,
  isLoaded,
  handleSync,
  validPermission
}) => {
  const methods = useForm({ defaultValues });
  const projectId = methods.getValues('project');
  const [t] = useTranslation();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onDelete = (project) => {
    handleDelete(project);
  };

  const onEdit = (project) => {
    handleEdit(project);
  };

  const columns = [
    { label: 'Name', key: 'name' },
    { label: 'Type', key: 'type_scm' },
  ];

  const onSync = (project) => {
    handleSync(project);
  }

  const getActions = (row) => {
    const actions = [];
    if (validPermission(projectId, 'isEdit') && (row.type_scm === 'Git' || row.type_scm === 'git')) {
      actions.push({
        label: t('projectList.components.table.sync'),
        icon: <SyncIcon color="primary" />,
        handle: onSync,
      });
    }

    if (validPermission(projectId, 'isEdit')) {
      actions.push({
        label: t('projectList.components.table.edit'),
        icon: <EditOutlinedIcon color="primary" />,
        handle: onEdit,
      });
    }

    if (validPermission(projectId, 'isDelete')) {
      actions.push({
        label: t('projectList.components.table.delete'),
        icon: <HighlightOffIcon color="primary" />,
        handle: onDelete,
      });
    }
    return actions;
  };

  


  return (
    <>
      <HeadlinePage
        title="projectList.headline"
        buttonLabel={validPermission(projectId, "isCreate") ? "projectList.components.add" : ""}
        handleOnClick={handleCreate}
      />

      <SearchBarBox
        onSubmit={onSubmit}
        methods={methods}
        hideProject={true}
        searchValue={searchValue}
      />

      <Paper sx={{ p: 2 }}>
        <TableCustom
          title="projectList.components.titleList"
          columns={columns}
          content={content}
          actions={getActions}
          loading={isLoaded}
          handleNotResults={handleCreate}
        />
      </Paper>
    </>
  )
}

export default withPermission(ProjectListDumb, "projects");
